import Icon from '../components/Icon.vue'

Icon.register({
  'ruler-horizontal': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M544 128c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32h-512c-17.7 0-32-14.3-32-32v-192c0-17.7 14.3-32 32-32h48v88c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-88h64v88c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-88h64v88c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-88h64v88c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-88h64v88c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-88h48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ruler-horizontal.js
// module id = 1851
// module chunks = 0